import _JSXStyle from "styled-jsx/style";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import { mutuallyExclusive, requiredIf } from '@dhis2/prop-types';
import { colors } from '@dhis2/ui-constants';
import cx from 'classnames';
import PropTypes from 'prop-types';
import React, { forwardRef } from 'react';
import styles from './table-data-cell.styles.js';
const rtlCorrespondingAlignments = {
  left: 'right',
  right: 'left',
  center: 'center'
};
export const TableDataCell = /*#__PURE__*/forwardRef((_ref, ref) => {
  var _rtlCorrespondingAlig;

  let {
    active,
    align,
    backgroundColor,
    bordered,
    children,
    className,
    colSpan,
    dataTest,
    error,
    large,
    left,
    muted,
    role,
    rowSpan,
    scope,
    staticStyle,
    valid,
    width,
    onClick,
    ...props
  } = _ref;
  const rtlAlign = (_rtlCorrespondingAlig = rtlCorrespondingAlignments[align]) !== null && _rtlCorrespondingAlig !== void 0 ? _rtlCorrespondingAlig : align;
  return /*#__PURE__*/React.createElement("td", _extends({}, props, {
    ref: ref,
    colSpan: colSpan,
    rowSpan: rowSpan,
    onClick: onClick,
    "data-test": dataTest,
    role: role,
    scope: scope,
    className: "jsx-".concat(styles.__hash) + " " + _JSXStyle.dynamic([["836058623", [left, align, width, backgroundColor || colors.white, rtlAlign, backgroundColor || colors.teal100, backgroundColor || colors.grey100, backgroundColor || colors.grey200, backgroundColor || '#cdeae8']]]) + " " + (cx(className, {
      active,
      bordered,
      error,
      large,
      muted,
      staticStyle,
      valid
    }) || "")
  }), children, /*#__PURE__*/React.createElement(_JSXStyle, {
    id: styles.__hash
  }, styles), /*#__PURE__*/React.createElement(_JSXStyle, {
    id: "836058623",
    dynamic: [left, align, width, backgroundColor || colors.white, rtlAlign, backgroundColor || colors.teal100, backgroundColor || colors.grey100, backgroundColor || colors.grey200, backgroundColor || '#cdeae8']
  }, ["td.__jsx-style-dynamic-selector{inset-inline-start:".concat(left, ";text-align:").concat(align, ";width:").concat(width, ";background-color:").concat(backgroundColor || colors.white, ";}"), ".__jsx-style-dynamic-selector:dir(rtl){text-align:".concat(rtlAlign, ";}"), "tr.selected>td.__jsx-style-dynamic-selector{background-color:".concat(backgroundColor || colors.teal100, ";}"), "tr:hover>td.__jsx-style-dynamic-selector:not(.staticStyle){background-color:".concat(backgroundColor || colors.grey100, ";}"), "tr:active>td.__jsx-style-dynamic-selector:not(.staticStyle){background-color:".concat(backgroundColor || colors.grey200, ";}"), "tr.selected:hover>td.__jsx-style-dynamic-selector:not(.staticStyle){background-color:".concat(backgroundColor || '#cdeae8', ";}")]));
});
TableDataCell.displayName = 'TableDataCell';
TableDataCell.defaultProps = {
  align: 'left',
  dataTest: 'dhis2-uicore-tabledatacel',
  left: 'auto',
  width: 'auto'
};
const stylePropType = mutuallyExclusive(['valid', 'error', 'muted'], PropTypes.bool);
TableDataCell.propTypes = {
  /** To toggle border color, for example for editing */
  active: PropTypes.bool,
  align: PropTypes.oneOf(['left', 'center', 'right']),

  /** Sets background color of the cell. Disables dynamic background colors from active, hover, and selected states */
  backgroundColor: PropTypes.string,
  bordered: PropTypes.bool,
  children: PropTypes.node,
  className: PropTypes.string,
  colSpan: PropTypes.string,
  dataTest: PropTypes.string,

  /** Mutually exclusive with muted and valid */
  error: stylePropType,
  large: PropTypes.bool,

  /** Required when fixed */
  left: requiredIf(props => props.fixed, PropTypes.string),

  /** Mutually exclusive with error and valid */
  muted: stylePropType,
  role: PropTypes.string,
  rowSpan: PropTypes.string,
  scope: PropTypes.string,

  /** Surpress hover and active event styles */
  staticStyle: PropTypes.bool,

  /** Mutually exclusive with error and muted */
  valid: stylePropType,
  width: PropTypes.string,
  onClick: PropTypes.func
};